export default {
  new: {
    sizings: {
      border: 10,
    },
    pallette: {
      red: {
        primary: '#EE6969',
      },
      green: {
        primary: '#50C964',
      },
      orange: {
        primary: '#F4A03C',
      },
    },
  },
};
